var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "password-black-18dp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ALLE",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Key_types",
    transform: "translate(-125.000000, -14.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Schl\\xFCssel_ARt",
    transform: "translate(25.338945, 10.166667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pincode_Tag_card_Activce",
    transform: "translate(96.152357, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "password-black-18dp",
    transform: "translate(3.855920, 4.600000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 11.5677609 0 11.5677609 10.7333333 0 10.7333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.26193756,8.17777778 L11.0770074,8.17777778 L11.0770074,9.2 L1.26193756,9.2 L1.26193756,8.17777778 Z M1.82630408,6.10777778 L2.24344455,5.35133333 L2.66058502,6.10777778 L3.29856456,5.72444444 L2.88142409,4.968 L3.71570503,4.968 L3.71570503,4.20133333 L2.88142409,4.20133333 L3.29856456,3.45 L2.66058502,3.06666667 L2.24344455,3.818 L1.82630408,3.06666667 L1.18832453,3.45 L1.605465,4.20133333 L0.771184063,4.20133333 L0.771184063,4.968 L1.605465,4.968 L1.18832453,5.72444444 L1.82630408,6.10777778 Z M5.11435249,5.72444444 L5.75233203,6.10777778 L6.1694725,5.35133333 L6.58661297,6.10777778 L7.22459252,5.72444444 L6.80745205,4.968 L7.64173299,4.968 L7.64173299,4.20133333 L6.80745205,4.20133333 L7.22459252,3.45 L6.58661297,3.06666667 L6.1694725,3.818 L5.75233203,3.06666667 L5.11435249,3.45 L5.53149296,4.20133333 L4.69721202,4.20133333 L4.69721202,4.968 L5.53149296,4.968 L5.11435249,5.72444444 Z M11.5677609,4.20133333 L10.73348,4.20133333 L11.1506205,3.45 L10.5126409,3.06666667 L10.0955005,3.818 L9.67835999,3.06666667 L9.04038045,3.45 L9.45752092,4.20133333 L8.62323998,4.20133333 L8.62323998,4.968 L9.45752092,4.968 L9.04038045,5.72444444 L9.67835999,6.10777778 L10.0955005,5.35133333 L10.5126409,6.10777778 L11.1506205,5.72444444 L10.73348,4.968 L11.5677609,4.968 L11.5677609,4.20133333 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinCode);
export default __webpack_public_path__ + "static/media/pin_code.f51f6b4de23283fc7e15c048f6c3c1df.svg";
export { ForwardRef as ReactComponent };